<ng-container *ngIf="showCustomAlert" class="container">
  <div class="component-area container">
    <p-toast>
      <strong>There are validation errors:</strong>
      <ul>
        <li *ngFor="let field of getErrorFields()">
          <strong>{{ field }}:</strong>
          <ul>
            <li *ngFor="let errorMessage of errorMessages[field]">
              {{ errorMessage }}
            </li>
          </ul>
        </li>
      </ul>
    </p-toast>
  </div>
</ng-container>

<router-outlet></router-outlet>

<app-toast></app-toast>

<ngx-spinner
  bdColor="rgba(0, 0, 0, 0.8)"
  size="medium"
  color="#fff"
  type="square-jelly-box"
  [fullScreen]="true"
>
  <p style="color: white">Loading...</p>
</ngx-spinner>
